export default {
  "auth-token_headline": "2-step authentication security",
  "auth-token_subhead": "To edit your information we'll need to send you a secure pin. Where would you like that sent?",
  "auth-token_prefix_email": "Email - ",
  "auth-token_prefix_text": "Text - ",
  "auth-token_prefix_call": "Call Me - ",
  "auth-token_error": "To edit your information we normally send you a secure pin.  However, you have no contact information on file with us.  Please call us at %groupTollFreePhone%.",
  "auth-token_response_error": "To edit your information we normally send you a secure pin.  However, we ran into a problem.  Please call us at %groupTollFreePhone%.",
};